import { render } from "./payAccountsModel.vue?vue&type=template&id=d15b871e"
import script from "./payAccountsModel.vue?vue&type=script&lang=js"
export * from "./payAccountsModel.vue?vue&type=script&lang=js"

import "./payAccountsModel.vue?vue&type=style&index=0&id=d15b871e&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__